import React, { useState } from "react";
import { FaAngleDown, FaAngleRight } from "react-icons/fa";
import "./style.css";
import { useNavigate } from "react-router-dom";

const Sidebar = ({
  setSelectedHeading,
  openSubheadingId,
  toggleSubheading,
  helpPageData,
  tertiaryId,
  setTertiaryId,
  setOpenSubheadingId,
  setHeadingClicked,
  loadPageContent,
  setMainHeading
}) => {
  const navigate = useNavigate();

  const handleHeadingClick = (heading) => {
    setSelectedHeading(heading);
    setMainHeading(heading.heading);
    setOpenSubheadingId(null);
    setHeadingClicked(true);
    setTertiaryId(null);
    navigate(`/help`);
  };

  const handleTertiaryData = (data) => {
    if (!loadPageContent) {
      setTertiaryId(data._id);
      navigate(`/help/${data._id}`);
      setHeadingClicked(false);
    }
  };

  const handleSubheadingClick = (dataId, subId, sub) => {
    if (!loadPageContent) {
      toggleSubheading(dataId, subId, sub);
      if (sub.tertiarySubHeadings && sub.tertiarySubHeadings.length > 0) {
        const firstTertiary = sub.tertiarySubHeadings[0];
        handleTertiaryData(firstTertiary);
      }
      setHeadingClicked(false);
    }
  };

  return (
    <div className="mainSideBar py-4 h-full border-r border-[#e5e7ea] FontFamily-Avenir-reg">
      {helpPageData &&
        helpPageData.map((data) => (
          <div className="w-full" key={data._id}>
            <h2
              className="FontFamily-Avenir text-base tracking-wide mt-4 text-[#505256] hover:text-[#707070] px-1 text-left cursor-pointer"
              onClick={() => handleHeadingClick(data)}
            >
              {data.heading}
            </h2>
            <ul>
              {data.subHeadings.map((sub) => (
                <li
                  className="flex flex-col justify-start w-full"
                  key={sub._id}
                >
                  <div
                    className="text-[#707070] hover:text-[#505256]  cursor-pointer w-full px-2 text-left flex items-center mt-3 text-[15px] leading-5 "
                    onClick={() =>
                      handleSubheadingClick(data._id, sub._id, sub)
                    }
                  >
                    <span className="flex-1">{sub.subHeading}</span>
                    <span className="ml-2">
                      {openSubheadingId === `${data._id}-${sub._id}` ? (
                        <FaAngleDown size={16} />
                      ) : (
                        <FaAngleRight size={16} />
                      )}
                    </span>
                  </div>
                  {openSubheadingId === `${data._id}-${sub._id}` && (
                    <ul className="text-[#707070] flex flex-col text-sm  pl-4 py-2">
                      {sub.tertiarySubHeadings.map((tertiary) => (
                        <li
                          key={tertiary._id}
                          onClick={() => handleTertiaryData(tertiary)}
                          className={`text-[14.5px] leading-5    hover:text-[#57a5e0] border-l hover:border-[#57a5e0] border-[#e5e7ea] text-left pl-4  py-[.6rem]  cursor-pointer capitalize ${
                            tertiaryId === tertiary._id
                              ? "text-[#57a5e0] border-[#57a5e0] FontFamily-Avenir " // Apply selected color when selected
                              : ""
                          }`}
                        >
                          {tertiary.tertiarySubHeading}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
    </div>
  );
};

export default Sidebar;
